module.exports = __webpack_public_path__ + "img/pump.9ff1d30c.jpg";